import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withMemo as _withMemo, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d8661b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-min-w-full tw-divide-y tw-divide-gray-200 table" }
const _hoisted_2 = { class: "tw-sticky tw-top-0 tw-z-[1]" }
const _hoisted_3 = {
  key: 0,
  class: "tw-w-[18px] table-header"
}
const _hoisted_4 = {
  key: 1,
  class: "tw-min-w-[37px] tw-py-3 tw-px-4 tw-text-sm tw-text-gray-700 table-header"
}
const _hoisted_5 = ["id", "onClick"]
const _hoisted_6 = { class: "tw-w-[max-content]" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  onmousedown: "return false",
  class: "!tw-w-[30px] tw-py-3 tw-px-4 tw-text-sm tw-text-gray-700 table-data"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick", "innerHTML"]
const _hoisted_11 = {
  key: "footer",
  role: "group",
  class: "empty-action-table-footer"
}
const _hoisted_12 = { colspan: "7" }
const _hoisted_13 = { class: "tw-flex tw-flex-col tw-content-center tw-items-center tw-gap-[40px] tw-rounded-[6px] tw-bg-[#FFFFFF] tw-px-[25px] tw-py-[50px]" }
const _hoisted_14 = { class: "tw-text-center tw-font-[400] tw-leading-[145%] tw-text-[15px] tw-text-[#878787]" }
const _hoisted_15 = { class: "add-button" }
const _hoisted_16 = {
  key: "footer",
  role: "group",
  class: "empty-action-table-footer"
}
const _hoisted_17 = { colspan: "7" }
const _hoisted_18 = { class: "empty-action-table tw-flex tw-flex-col tw-content-center tw-items-center tw-gap-[40px] tw-rounded-[6px] tw-bg-[#FFFFFF]" }
const _hoisted_19 = { class: "tw-text-center tw-font-[400] tw-leading-[145%] tw-text-[15px] tw-text-[#878787]" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 0,
  class: "tw-w-[18px] table-data !tw-pr-[10px] tw-cursor-pointer"
}
const _hoisted_22 = {
  key: 1,
  class: "!tw-w-[30px] tw-py-3 tw-px-4 tw-text-sm tw-text-gray-700 table-data"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick", "innerHTML"]
const _hoisted_25 = { class: "detail" }
const _hoisted_26 = ["colspan"]
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "tr-empty" }
const _hoisted_29 = ["colspan"]
const _hoisted_30 = {
  class: "tw-w-full tw-text-[#878787] tw-text-[13px] tw-font-medium tw-text-center",
  style: {"font-family":"Poppins"}
}
const _hoisted_31 = {
  key: 2,
  class: "!tw-border-t-[1px] !tw-border-0 !tw-border-solid !tw-border-[#EFF0F1]"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_custom_check_box = _resolveComponent("custom-check-box")!
  const _component_SwapIcon = _resolveComponent("SwapIcon")!
  const _component_DraggableIcon = _resolveComponent("DraggableIcon")!
  const _component_VueDraggable = _resolveComponent("VueDraggable")!
  const _component_TableSkeleton = _resolveComponent("TableSkeleton")!

  return (_openBlock(), _createElementBlock("div", {
    class: "shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] rounded-md border-solid border-[#EFF0F1] tw-max-h-[100%] tw-overflow-auto tableWrapper",
    onScroll: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
  }, [
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("thead", _hoisted_2, [
        _createElementVNode("tr", {
          class: _normalizeClass(`tw-bg-[#FFF] tw-h-[44px] table-row !tw-border-0 ${_ctx.headerWrapperClass}`)
        }, [
          (_ctx.draggable)
            ? (_openBlock(), _createElementBlock("th", _hoisted_3))
            : _createCommentVNode("", true),
          (_ctx.showCheckboxRow)
            ? (_openBlock(), _createElementBlock("th", _hoisted_4, [
                _createVNode(_component_custom_check_box, {
                  class: _normalizeClass(`tw-h-[20px] !tw-mb-0 ${_ctx.draggable ? '!tw-pl-0' : ''}`),
                  size: "20px",
                  "color-checkmark": _ctx.colorCheckmark,
                  "is-checked": _ctx.selectAll,
                  "onUpdate:isChecked": _cache[0] || (_cache[0] = (value) => _ctx.onSelectAllChanged(value))
                }, null, 8, ["class", "color-checkmark", "is-checked"])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, index) => {
            return (_openBlock(), _createElementBlock("th", {
              key: column.value,
              class: _normalizeClass(`tw-py-3 tw-px-4 tw-text-sm tw-text-gray-700 table-header tw-pr-10 ${
              column.text === 'mfa enabled' ? 'tw-w-[104px]' : ''
            }`)
            }, [
              _createElementVNode("span", {
                id: `${column.headerWrapperId}`,
                class: _normalizeClass([
                `tw-flex tw-item-center tw-gap-[4px] tw-select-none tw-items-center`,
                column.headerClass ? column.headerClass : '',
                column.sortable ? 'tw-cursor-pointer' : '',
                _ctx.columnActive === index
                  ? `!tw-text-[${_ctx.textHeaderSortActiveDefault}]`
                  : `!tw-text-[${_ctx.textHeaderDefault}]`,
              ]),
                onClick: ($event: any) => (_ctx.clickSortHeader(column, index))
              }, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(column.text), 1),
                (column.sortable)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                      _createVNode(_component_SwapIcon, {
                        color: 
                    _ctx.columnActive === index
                      ? _ctx.textHeaderSortActiveDefault
                      : _ctx.textHeaderDefault
                  
                      }, null, 8, ["color"])
                    ]))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_5)
            ], 2))
          }), 128))
        ], 2)
      ]),
      _withDirectives(_createVNode(_component_VueDraggable, {
        list: _ctx.sortedData,
        tag: "tbody",
        "item-key": "id",
        group: "action",
        handle: ".drag-handle",
        class: "drag-drop-table",
        onChange: _ctx.changeItem
      }, {
        item: _withCtx(({ element }) => [
          _withMemo([element], () => (_openBlock(), _createElementBlock("tr", {
            class: _normalizeClass(`table-row ${_ctx.isGlobalSearch ? 'tw-cursor-pointer' : ''}`),
            style: _normalizeStyle(`background-color: ${
              _ctx.selectedRows.includes(element.id)
                ? '#F2F8FF'
                : element.rowBgColor || ''
            }`)
          }, [
            (_ctx.draggable)
              ? (_openBlock(), _createElementBlock("td", {
                  key: 0,
                  class: _normalizeClass(`tw-w-[18px] table-data !tw-pr-[10px] ${
                element.templateType !== _ctx.templateType.system ||
                _ctx.tableType !== _ctx.tableTypeConstant.VENDORTEMPLATE
                  ? 'tw-cursor-pointer'
                  : ''
              }`)
                }, [
                  (
                  element.templateType !== _ctx.templateType.system ||
                  _ctx.tableType !== _ctx.tableTypeConstant.VENDORTEMPLATE
                )
                    ? (_openBlock(), _createBlock(_component_DraggableIcon, {
                        key: 0,
                        class: "drag-handle"
                      }))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.showCheckboxRow)
              ? (_openBlock(), _createElementBlock("td", _hoisted_8, [
                  _createVNode(_component_custom_check_box, {
                    type: _ctx.type,
                    class: "!tw-mb-0 tw-h-[20px] !tw-pl-0",
                    size: "20px",
                    "is-checked": _ctx.selectedRows.includes(element.id),
                    "onUpdate:isChecked": () => _ctx.toggleRow(element.id, element)
                  }, null, 8, ["type", "is-checked", "onUpdate:isChecked"])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
              return (_openBlock(), _createElementBlock("td", {
                key: column.value,
                onmousedown: "return false",
                class: _normalizeClass(`tw-py-3 tw-px-4 tw-text-sm tw-text-gray-700 ${
                column.valueClass ? column.valueClass : ''
              } table-data`),
                onClick: (e) => _ctx.$emit('clicked-row', element, column, e)
              }, [
                _renderSlot(_ctx.$slots, 'cell(' + column.value + ')', {
                  tablePrefix: 'VueDraggableTable',
                  value: element[column.value],
                  item: element
                }, () => [
                  (typeof column.render === 'function')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "tw-flex tw-w-[max-content]",
                        onClick: ($event: any) => (_ctx.getAttachment(element)),
                        innerHTML: 
                      _ctx.getSafeHTML(
                        column.value === '*'
                          ? column.render(element)
                          : column.render(element[column.value]),
                      )
                    
                      }, null, 8, _hoisted_10))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(element[column.value]), 1)
                      ], 64))
                ], true)
              ], 10, _hoisted_9))
            }), 128))
          ], 6)), _cache, 1)
        ]),
        footer: _withCtx(() => [
          (_ctx.tableType === _ctx.tableTypeConstant.ACTIONS && !_ctx.data.length)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                _createElementVNode("td", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createTextVNode(_toDisplayString(_ctx.getUiText(
                      "app-assess-recommendations-section-action-empty-action-table-title-1",
                    )) + " ", 1),
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.getUiText(
                        "app-assess-recommendations-section-action-empty-action-table-title-2",
                      )), 1),
                      _createTextVNode(", " + _toDisplayString(_ctx.getUiText(
                      "app-assess-recommendations-section-action-empty-action-table-title-3",
                    )), 1)
                    ]),
                    _createElementVNode("span", {
                      class: "tw-cursor-pointer tw-text-center tw-font-[500] tw-leading-[145%] tw-text-[11px] tw-text-[#387DFF]",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleAddAction && _ctx.handleAddAction(...args)))
                    }, _toDisplayString(_ctx.getUiText(
                      "app-assess-recommendations-section-action-empty-action-table-sub-title-1",
                    )), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (
              _ctx.tableType === _ctx.tableTypeConstant.SUGGESTEDACTIONS && !_ctx.data.length
            )
            ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                _createElementVNode("td", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.getUiText(
                      "app-assess-recommendations-section-action-empty-suggest-action-table-title-1",
                    )), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["list", "onChange"]), [
        [_vShow, !_ctx.idItemExpland && !_ctx.isLoading]
      ]),
      (_ctx.isRecommend || _ctx.idItemExpland)
        ? _withDirectives((_openBlock(), _createElementBlock("tbody", _hoisted_20, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedData, (item) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: item.id
              }, [
                _createElementVNode("tr", {
                  class: "table-row",
                  style: _normalizeStyle(`background-color: ${
              _ctx.selectedRows.includes(item.id) ? '#F2F8FF' : item.rowBgColor || ''
            } `)
                }, [
                  (_ctx.draggable)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_21, [
                        _createVNode(_component_DraggableIcon)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.showCheckboxRow)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_22, [
                        _createVNode(_component_custom_check_box, {
                          id: item.id,
                          class: "!tw-mb-0 tw-h-[20px] !tw-pl-0",
                          size: "20px",
                          "color-checkmark": _ctx.colorCheckmark,
                          "is-checked": _ctx.selectedRows.includes(item.id),
                          "onUpdate:isChecked": () => _ctx.toggleRow(item.id, item)
                        }, null, 8, ["id", "color-checkmark", "is-checked", "onUpdate:isChecked"])
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
                    return (_openBlock(), _createElementBlock("td", {
                      key: column.value,
                      class: _normalizeClass(`tw-py-3 tw-px-4 tw-text-sm tw-text-gray-700 ${
                column.valueClass ? column.valueClass : ''
              } table-data`),
                      onClick: (e) => _ctx.$emit('clicked-row', item, column, e)
                    }, [
                      _renderSlot(_ctx.$slots, 'cell(' + column.value + ')', {
                        value: item[column.value],
                        item: item
                      }, () => [
                        (typeof column.render === 'function')
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "tw-flex tw-w-[max-content]",
                              onClick: ($event: any) => (_ctx.getAttachment(item)),
                              innerHTML: 
                      _ctx.getSafeHTML(
                        column.value === '*'
                          ? column.render(item)
                          : column.render(item[column.value]),
                      )
                    
                            }, null, 8, _hoisted_24))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(item[column.value]), 1)
                            ], 64))
                      ], true)
                    ], 10, _hoisted_23))
                  }), 128))
                ], 4),
                _withDirectives(_createElementVNode("tr", _hoisted_25, [
                  _createElementVNode("td", {
                    colspan: _ctx.columns.length + 2,
                    class: "detail_content"
                  }, [
                    _renderSlot(_ctx.$slots, 'detail', {
                      item: item,
                      value: item.id === _ctx.idItemExpland
                    }, undefined, true)
                  ], 8, _hoisted_26)
                ], 512), [
                  [_vShow, item.id === _ctx.idItemExpland]
                ])
              ], 64))
            }), 128))
          ], 512)), [
            [_vShow, _ctx.idItemExpland]
          ])
        : _createCommentVNode("", true),
      (
          !_ctx.isLoading &&
          !_ctx.data?.length &&
          (_ctx.tableType === _ctx.tableTypeConstant.ASSESSMENTTABLE ||
            _ctx.tableType === _ctx.tableTypeConstant.VENDORTEMPLATE)
        )
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_27, [
            _createElementVNode("tr", _hoisted_28, [
              _createElementVNode("td", {
                colspan: _ctx.showCheckboxRow ? _ctx.columns.length + 2 : _ctx.columns.length
              }, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.emptyText || ""), 1)
                ])
              ], 8, _hoisted_29)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isLoading || _ctx.isLoadingNewData)
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_31, [
            _createVNode(_component_TableSkeleton, {
              "rows-number": _ctx.isLoadingNewData ? 1 : 3,
              "columns-number": 
            _ctx.columns.length + (_ctx.draggable ? 1 : 0) + (_ctx.showCheckboxRow ? 1 : 0)
          
            }, null, 8, ["rows-number", "columns-number"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 32))
}